import Swiper from 'swiper';
import {Modal} from './Modal';
import $ from 'jquery';
import 'magnific-popup';
//import 'packery';

document.addEventListener('DOMContentLoaded', () => {

    var swiper = new Swiper('.swiper-container', {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
            nextEl: '.next',
            prevEl: '.prev',
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        }
    });
    var swiper_ressource = new Swiper('.swiper-container-crea', {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesPerGroup: 2,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
            nextEl: '.next-crea',
            prevEl: '.prev-crea',
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
        }
    });
});

let nav = document.querySelector('nav .menu .burger');
if (nav) {
    nav.addEventListener('click', e => {
       if (!nav.classList.contains('open')) {
           document.querySelector('nav .menu .main-menu').classList.add('open');
           nav.classList.add('open');
       } else {
           document.querySelector('nav .menu .main-menu').classList.remove('open');
           nav.classList.remove('open');
       }
    });
}

let blockTitre = document.querySelector('.block-titre');

if (blockTitre) {
    blockTitre.addEventListener('click', function () {

        var info = document.querySelector('.informations');
        var btn = document.querySelector('.ouvrir');

        var animationPlayed = btn.classList.contains('animOpen');

        if (!animationPlayed) {
            info.classList.remove('animClose');
            info.classList.add('animOpen');
            btn.classList.remove('animClose');
            btn.classList.add('animOpen');
            btn.style.transform = 'rotate(180deg)';

        } else {
            info.classList.remove('animOpen');
            info.classList.add('animClose');
            btn.classList.remove('animOpen');
            btn.classList.add('animClose');
            btn.style.transform = '';

        }

    });
}

let selectClient = document.querySelector('.ressources select[name=client]');

if (selectClient) {

    let selectTemplate = document.querySelector('.ressources select[name=template]');
    if (selectTemplate) {
        let templates = Array.from(selectTemplate.querySelectorAll('option'));

        selectClient.addEventListener('change', function () {

            templates.forEach((template) => {
                if (template.dataset.client !== selectClient.value && template.dataset.client && selectClient.value) {
                    template.remove();
                } else {
                    selectTemplate.appendChild(template);
                }
            });

        });
    }
}

let svgComment = document.querySelector('.row.presentation .pre-title .comments');

if (svgComment) {

    svgComment.addEventListener('click', function () {
        let blockComments = document.querySelector('.row.commentaires');

        window.scrollTo({top: getElementOffset(blockComments).top, behavior: 'smooth'});

    });
}

function getElementOffset(el) {
    const rect = el.getBoundingClientRect();

    return {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset,
    };
}


if ($('.caption').length) {

    $('.caption').magnificPopup({
        type: 'image',
        fixedBgPos: true,
        fixedContentPos: true

    });
}

if ($('button.show-comment').length) {
    $('button.show-comment').click(function () {
        $(this).next('div.comment').slideToggle(500);
        $(this).toggleClass('actif');
        if ($(this).hasClass('actif')) {
            $(this).html('Fermez le commentaire X');
        } else {
            $(this).html('Voir le commentaire ↓');
        }
    });
}


if ($('.open-modal').length) {
    $('.open-modal').magnificPopup({
        type: 'inline',
        showCloseBtn: false,

        fixedContentPos: true,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: 'mfp-move-from-top'
    });
}

if ($('#modal-validate').length) {
    $.magnificPopup.open({
        items: {
            src: '#modal-validate'
        },
        type: 'inline',
        showCloseBtn: false,

        fixedContentPos: true,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: 'mfp-move-from-top'
    });
}


if ($('.modal-close').length) {
    $('.modal-close').click(function () {
        $.magnificPopup.close();
    });
}

var sel_client = document.getElementById('client');
var sel_gab = document.getElementById('gabarit');
var gab_option = document.querySelectorAll("#gabarit option");

function getSelectedOption(sel_client) {
    var opt;
    for ( var i = 0, len = sel_client.options.length; i < len; i++ ) {
        opt = sel_client.options[i];
        if ( opt.selected === true ) {
            break;
        }
    }
    return opt;
}
if(document.getElementById('client')){
    document.getElementById('client').onchange = function () {

        for ( var i = 0, len = sel_gab.options.length; i < len; i++ ) {

            var gab = gab_option[i].dataset.template;
            if (sel_client.value == gab) {
                gab_option[i].style.display ="block";
            }else {
                gab_option[i].style.display ="none";
            }
        }
    };
}


